import React, { Component } from "react";
import Stepper from "@components/Stepper/Stepper";
// import StepperHorizontal from "../../../../components/Stepper/StepperHorizontal";
import DatePicker from "react-datepicker";
import axios from "axios";
import Modal from "react-modal";
import moment from "moment";
import apiEndpoints from "@store/apiEndpoints";
import errorFunctions from "@store/errorFunctions";
import referenceLibrary from "@store/referenceLibrary";
import { getStatusLabel } from "@store/utilityFunctions";
import Select from "react-select";
import { Tooltip } from "@material-ui/core";
import {
  DueDateModal,
  StatusConfirmModal,
  ServiceTypeModal,
  AssignToModal,
  AssignStoreLocationModal,
  ApproveModal,
  DeclineModal,
  NextStepModal,
  TicketNextModal,
  ServiceCenterModal,
  GoodReceivedModal,
  ReplacementModal,
  ReturnLabelModal,
  ShippingModal,
} from "./modals";

Modal.setAppElement("body");

export default class TicketProcess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      due_date: new Date(moment().add(2, "d").format("YYYY-MM-DD")),
      showDueDateModal: false,
      statusTicket: this.props.details?.status || "",
      typeService: this.props.details?.type_of_service || "",
      statusTicketType: this.props.details?.ticket_type || "",
      modalStatusConfirm: false,
      replacementModal: false,
      selectedReplacement: this.props.deviceOptions?.find(
        (x) => x.value === this.props.details?.replacement,
      ),
      employeeID: this.props.details?.assigned_to || "",
      solvupId: this.props.details?.solvup_id || "",
      inboundTicket: this.props.details?.inbound_ticket || "",
      outboundTicket: this.props.details?.outbound_ticket || "",

      employeeName: "",
      refundAmount:
        this.formatDecimalValue(this.props.details?.refund_amount) || 0,
      showGoodReceived: false,
      ticketID: this.props.details?.id || 0,

      serviceCenterCentrals: this.props.serviceCenterCentrals,
      selectedServiceCenters: [],
      optionServiceCenterCentrals: this.props.optionServiceCenterCentrals,
      optionServiceCenter: [],
      deviceOptions: [],
      serviceCenters: undefined,
      serviceCenterCentralId: this.props.details?.service_center_central || 0,
      serviceCenterCentralName:
        this.props.optionServiceCenterCentrals?.find(
          (sc) => sc.value == this.props.details?.service_center_central || 0,
        )?.label || "",
      serviceCenterLocationId: this.props.details?.service_center || 0,
      modalServiceCenter: false,
      optionEmployees: this.props.optionEmployees,
      newAssignTo: false,
      newServiceCenter: false,
      trackingNumber: this.props.details?.tracking_number || "",
      nextStatus: "",
      isDoa: this.props.details?.is_doa ?? null,
      showDoaModal: false,
      createdByRole: this.props.details?.created_by_role,
      isDisabled: ["Commercial Admin", "Commercial Staff"].includes(
        this.props.userInfo.user.role,
      ),
      storeLocationId: this.props.details?.store_location,
      storeLocationLabel: "",
      serviceCenterLocationData: null,
    };
  }

  retrieveServiceCenterLocationById = (serviceCenterCentralId) => {
    if (!serviceCenterCentralId) return;

    this.props
      .protectedFetch(
        apiEndpoints.serviceCenterCentral.detail(serviceCenterCentralId),
        "GET",
        null,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        this.setState({
          serviceCenterLocationData: res,
        });
      })
      .catch((err) => {
        console.log("Failed to fetch service center location", err);
      });
  };

  componentDidMount() {
    if (this.state.isDisabled)
      this.disableAllElements(document.getElementById("ticket-process"));

    // Fetch service center location data if it exists
    if (this.state.serviceCenterCentralId) {
      this.retrieveServiceCenterLocationById(this.state.serviceCenterCentralId);
    }
  }

  disableAllElements = (element) => {
    const inputs = element.getElementsByTagName("input");
    const buttons = element.getElementsByTagName("button");
    const selects = element.getElementsByTagName("select");

    for (let input of inputs) {
      input.disabled = true;
    }
    for (let button of buttons) {
      button.disabled = true;
    }
    for (let select of selects) {
      select.disabled = true;
    }

    for (let child of element.children) {
      this.disableAllElements(child);
    }
  };

  handleStatusTicket = (e) => {
    this.setState({ statusTicket: e.value, modalStatusConfirm: true });
  };

  handleConfirmTicket = (e) => {
    this.setState({ loading: true });
    e.preventDefault();
    let payload = {
      status: this.state.statusTicket,
    };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.status(this.props.details?.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.setState({ modalStatusConfirm: false, loading: false });
        this.props.retrieveWarranty(); //mini reload
      })
      .catch((err) => {
        console.log("fail", err);
        this.setState({ modalStatusConfirm: false, loading: false });
      });
  };

  formatDecimalValue = (val) => {
    const value = val?.toString().replace(/,/g, "") || 0;
    return parseFloat(value).toLocaleString("en-AU", {
      style: "decimal",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };

  handleSubmitRefund = (e) => {
    e.preventDefault();

    let amountToSubmit = Number(this.state.refundAmount).toFixed(2);
    if (amountToSubmit === "NaN") {
      alert("Please input valid number");
    } else {
      let payload = {
        refund_amount: amountToSubmit,
      };
      this.props
        .protectedFetch(
          apiEndpoints.ticket.refund(this.props.details?.id),
          "PUT",
          payload,
          errorFunctions.checkResponseThenJson,
        )
        .then((res) => {
          if (res.refund_amount) {
            alert("Refund has successfully changed");
            this.props.retrieveWarranty(this.props.details?.id); //mini reload
          }
        })
        .catch((err) => {
          console.log("fail refund", err);
        });
    }
  };

  handleSubmitSolvupId = (e) => {
    e.preventDefault();

    let payload = {
      solvup_id: this.state.solvupId,
    };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.setSolvup(this.props.details.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        if (res.solvup_id) {
          alert("Solvup ID has successfully saved");
          this.props.retrieveWarranty(this.props.details.id); //mini reload
        }
      })
      .catch((err) => {
        console.log("fail Solvup", err);
      });
  };

  handleSubmitInboundTicket = (e) => {
    e.preventDefault();

    let payload = {
      inbound_ticket: this.state.inboundTicket,
    };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.setInboundTicket(this.props.details.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        alert("Inbound has successfully saved");
        this.props.retrieveWarranty(this.props.details.id); //mini reload
      })
      .catch((err) => {
        console.log("fail Inbound", err);
      });
  };

  handleSubmitOutboundTicket = (e) => {
    e.preventDefault();

    let payload = {
      outbound_ticket: this.state.outboundTicket,
    };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.setOutboundTicket(this.props.details.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        alert("Outbound has successfully saved");
        this.props.retrieveWarranty(this.props.details.id); //mini reload
      })
      .catch((err) => {
        console.log("fail Outbound", err);
      });
  };

  handleSubmitTrackingNumber = (e) => {
    e.preventDefault();
    if (!this.state.trackingNumber) {
      alert("Tracking number is empty, please fill it");
      return;
    }
    let payload = {
      tracking_number: this.state.trackingNumber,
    };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.trackingNumber(this.props.details?.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then((res) => {
        if (res.tracking_number) {
          alert("Tracking number successfully saved");
          this.props.retrieveWarranty(this.props.details?.id); //mini reload
        }
      })
      .catch((err) => {
        console.log("fail ticket number saved", err);
      });
  };
  handleTicketTypeChanges = (e) => {
    e.preventDefault();
    this.setState({ statusTicketType: e.target.value, modalServiceType: true });
  };

  handleChangeStatusTicketType = (e) => {
    e.preventDefault();

    let payload = {
      ticket_type:
        this.state.statusTicketType === "out_of_warranty"
          ? "out_of_warranty"
          : "warranty",
      type_of_service: this.state.typeService || "",
    };

    this.props
      .protectedFetch(
        apiEndpoints.ticket.changeType(this.props.details?.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.props.retrieveWarranty(this.props.details?.id); //mini reload
        this.setState({
          modalServiceType: false,
          typeService: "",
          statusTicketType: "",
        });
      })
      .catch((err) => {
        console.log("fail", err);
        this.props.retrieveWarranty(this.props.details?.id); //mini reload
        this.setState({
          modalServiceType: false,
          typeService: "",
          statusTicketType: "",
        });
        alert("Error try later");
      });
  };
  handleStatusTicketTypeModal = (e) => {
    e.preventDefault();
    if (e.target.value !== "") {
      this.setState({ modalServiceType: true, typeService: e.target.value });
    } else {
      alert("Must not empty");
      this.setState({ modalServiceType: false, typeService: "" });
    }
  };
  changeDueDate = (note) => {
    this.setState({ disableBtnDueDate: true });
    if (!this.state.showDueDateModal && !note) return;
    if (!this.state.showDueDateChangeModal && note) return;

    const data = {
      reason: "",
      due_date: moment(this.state.due_date).format("YYYY-MM-DD"),
    };

    const url = apiEndpoints.ticket.setDueDate(this.props.details?.id);
    this.props
      .protectedFetch(url, "PUT", data, errorFunctions.checkResponseThenJson)
      .then(() => {
        if (this.state.dueDateType === "note") this.handleAddNote();
        else if (this.state.dueDateType === "media") this.handleAddMedia();
        this.setState({
          dueDateReason: "",
          showDueDateModal: false,
          showDueDateChangeModal: false,
          disableBtnDueDate: false,
        });
        this.props.retrieveWarranty(this.ticketId);
      })
      .catch((error) => {
        // Handle the error or show an error message
        alert(
          error?.response?.data?.non_field_errors?.[0] ||
            error?.response?.data?.serial_number?.[0] ||
            "Something went wrong.. try later",
        );
        this.setState({ isLoading: false, showDueDateModal: false });
      });
  };

  handleDropDownAssignTo = (e) => {
    if (e.value !== this.state.employeeID) this.setState({ newAssignTo: true });
    this.setState({ employeeID: e.value, employeeName: e.label });
  };

  handleDropDownReplacement = (e) => {
    const selectedReplacement = this.state.deviceOptions.find(
      (x) => x.value === e.value,
    );
    this.setState({ replacement: e.value, selectedReplacement });
  };
  handleDropDownServiceCenterCentral = (e) => {
    // const tempSelectedServiceCenter = this.props.serviceCenters.find((x) => x.id === parseInt(e.target.value));
    if (e.value !== this.state.serviceCenterCentralId) {
      const selectedServiceCenter = this.props.serviceCenterCentrals?.find(
        (x) => x.id == e.value,
      ).service_centers;

      const selectedServiceCenterOption = selectedServiceCenter?.map((s) => {
        return { value: s.id, label: s.name };
      });
      this.setState({
        optionServiceCenter: selectedServiceCenterOption,
        selectedServiceCenters: selectedServiceCenter,
        serviceCenterCentralId: e.value,
        newServiceCenter: true,
      });
      if (!this.props.details?.service_center_central)
        this.setState({ modalServiceCenter: true });
      else {
        this.handleSubmitServiceCenterCentral(e.value);
      }
      this.retrieveServiceCenterLocationById(e.value);
    }
  };

  handleDropDownServiceCenterLocation = (e) => {
    if (e.value !== this.state.serviceCenterLocationId) {
      this.setState({
        serviceCenterLocationId: e.value,
        newServiceCenter: true,
      });

      this.handleSubmitServiceCenterLocation(e.value);
    }
  };
  handleSubmitAssign = () => {
    // e.preventDefault();

    let payload = {
      assigned_to: this.state.employeeID,
    };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.assign(this.props.details?.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.setState({ showAssignModal: false });
        this.props.retrieveWarranty();
        //mini reload
      })
      .catch(() => {
        console.log("fail");
      });
  };

  handleCancel = () => {
    this.props.retrieveWarranty(this.ticketId); //mini reload
    this.setState({
      showAssignModal: false,
      modalStatusConfirm: false,
      modalServiceCenter: false,
      modalNext: false,
      modalServiceType: false,
      statusTicketType: "",
      typeService: "",
    });
  };
  handleApprove = (e) => {
    e.preventDefault();
    if (this.state.isDoa === null) {
      alert("Please select DOA or Non-DOA before approving.");
      return;
    }
    this.setState({ loading: true, showApproveModal: false });
    const payload = { dead_on_arrival: this.state.isDoa };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.setDoa(this.props.details?.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => this.approveTicket(this.props.details?.id))
      .catch(() => this.approveTicket(this.props.details?.id));
  };
  approveTicket(id) {
    this.props
      .protectedFetch(
        apiEndpoints.ticket.approve(id),
        "PUT",
        null,
        errorFunctions.checkResponseSent,
      )
      .then(() => {
        this.props.retrieveWarranty(id);
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  }
  replacement = () => {
    // e.preventDefault();
    let payload = {
      replacement: this.state.replacement,
    };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.replacement(this.props.details?.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseSent,
      )
      .then(() => {
        this.props.retrieveWarranty(this.props.details?.id);
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };
  handleDecline = (e) => {
    this.setState({ loading: true, showDeclineModal: false });
    e.preventDefault();
    this.declineTicket(this.state.declineReason, this.props.details?.id);
  };
  declineTicket = (data, id) => {
    let reason = { note: data };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.reject(id),
        "PUT",
        reason,
        errorFunctions.checkResponseSent,
      )
      .then(() => {
        this.addNote({ note: `Reason declined: ${data}` }, id);
        this.retrieveWarranty(id);
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  addNote(formData, ticketId) {
    // const userInfo = localStorage.getItem("lgn") || utilityFunctions.getCookie("userInfo");
    const token = this.props.userInfo.access_token;
    let options = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    };

    const url = apiEndpoints.ticket.note(ticketId);
    axios
      .put(url, formData, options)
      .then(() => {
        this.setState({
          addedNote: "",
          editedNote: null,
          showAddNote: false,
          showAddMedia: false,
          disableBtnNote: false,
        });
        this.props.retrieveWarranty(ticketId);
      })
      .catch((error) => {
        // Handle the error or show an error message
        alert(
          error?.response?.data?.non_field_errors?.[0] ||
            error?.response?.data?.serial_number?.[0] ||
            "Something went wrong.. try later",
        );
        this.setState({ isLoading: false });
      });
  }

  handleNextModalOpen = () => {
    this.setState({ modalNext: true });
  };
  handleServiceNext = (e) => {
    const { details } = this.props;
    const listProgress = details?.ticket_status_list;
    const currentProgress = details?.status;

    let currentIndex = listProgress.indexOf(currentProgress);
    let isLastIndex = currentIndex === listProgress.length - 1;
    let getNextIndexValue =
      this.state.nextStatus || listProgress[currentIndex + 1];

    if (isLastIndex || currentProgress?.includes("Completed")) {
      alert("Service done");
    } else {
      this.setState({ loading: true });
      e?.preventDefault();
      let payload = {
        status: getNextIndexValue,
      };
      this.props
        .protectedFetch(
          apiEndpoints.ticket.status(this.props.details?.id),
          "PATCH",
          payload,
          errorFunctions.checkResponseThenJson,
        )
        .then(() => {
          this.setState({ modalNext: false, loading: false });
          this.props.retrieveWarranty(this.ticketId); //mini reload
        })
        .catch((err) => {
          console.log("fail", err);
          this.setState({ modalNext: false, loading: false });
        });
    }
  };
  handleInputChange = (e) => {
    const { id, value } = e.target;
    this.setState({
      [id]: value,
    });
  };

  handleSubmitServiceCenterLocation = (id) => {
    // e.preventDefault();
    const payload = {
      service_center: id || this.state.serviceCenterLocationId,
    };

    this.props
      .protectedFetch(
        apiEndpoints.ticket.serviceCenter(this.props.details?.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.setState({
          modalServiceCenter: false,
          serviceCenterId: payload.service_center,
        });
        this.props.retrieveWarranty(this.ticketId); //mini reload
      })
      .catch(() => {
        console.log("fail");
      });
  };

  handleSubmitServiceCenterCentral = (id) => {
    // e.preventDefault();
    const payload = {
      service_center_central: id || this.state.serviceCenterCentralId,
    };
    this.props
      .protectedFetch(
        apiEndpoints.ticket.serviceCenterCentral(this.props.details?.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        this.setState({
          modalServiceCenter: false,
          serviceCenterCentralId: payload.service_center_central,
        });
        this.props.retrieveWarranty(this.ticketId); //mini reload
      })
      .catch(() => {
        console.log("fail");
      });
  };
  handleFileUpload = (e) => {
    // TODO - verify file upload to make sure it's good
    const file = e.target.files[0];
    const allowedTypes = ["application/pdf"];

    const imageFile = URL.createObjectURL(file);
    const uploadFile = document.getElementById("uploadFile").files[0];
    this.setState({
      image: imageFile,
      imageName: file.name,
      uploadFile: uploadFile,
    });

    if (!allowedTypes.includes(file?.type)) {
      alert("Only PDF");
      this.setState({ allowUpload: false });
    } else {
      this.setState({ allowUpload: true });
    }
    // const video = document.getElementById("uploadFile").files[0];
    // const videos = [...this.state.newVideoFiles, video];
    // const videoFiles = [...this.state.videoFiles, video];
    // this.setState({ newVideoFiles: videos, videoFiles: videoFiles, newVideoName: video.name });
  };

  uploadLabel = () => {
    let formData = new FormData();
    formData.append("return_label", this.state.uploadFile);
    // const userInfo = localStorage.getItem("lgn") || utilityFunctions.getCookie("userInfo");
    const token = this.props?.userInfo?.access_token;
    let options = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    };

    const url = apiEndpoints.ticket.returnLabel(this.props.details?.id);

    axios
      .patch(url, formData, options)
      .then(() => {
        this.setState({
          showShipping: false,
        });
        this.handleServiceNext();
        this.props.retrieveWarranty();
      })
      .catch(() => {
        // Handle the error or show an error message
        // if(error) alert(error?.response?.data?.non_field_errors?.[0] || error?.response?.data?.serial_number?.[0] || "Something went wrong.. try later");
        this.setState({ showEditNote: false });
      });
    this.props.retrieveWarranty();
  };

  sentRetunLabelLink = () => {
    const token = this.props?.userInfo?.access_token;
    let options = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };

    const url = apiEndpoints.ticket.returnLabelUrl(this.props.details?.id);

    axios
      .patch(url, null, options)
      .then(() => {
        this.setState({
          showShipping: false,
        });
        this.handleServiceNext();
        this.props.retrieveWarranty();
      })
      .catch(() => {
        // Handle the error or show an error message
        // if(error) alert(error?.response?.data?.non_field_errors?.[0] || error?.response?.data?.serial_number?.[0] || "Something went wrong.. try later");
        this.setState({ showReturnLabel: false });
      });
    this.props.retrieveWarranty();
  };

  getStatusIndex = (status) => {
    return this.props.details?.ticket_status_list?.indexOf(status) === -1
      ? 0
      : this.props.details?.ticket_status_list.indexOf(status);
  };

  isReturnLabelSent = () => {
    const status = this.props.details?.status || "";
    const returnLabelStatuses = [
      "Awaiting Confirmation / Pending Approval",
      "Approved - Pending acceptance of Assessment Fee",
      "Assessment Fee Accepted - Pending Paying",
      "Assessment Fee Paid - Pending Return Label to be Sent",
      "Pending Return Label to be Sent",
    ];

    return returnLabelStatuses.some((labelStatus) =>
      status.includes(labelStatus),
    );
  };

  handleChangeTicketLocation = () => {
    this.setState({ loading: true });

    let payload = {
      store_location: this.state.storeLocationId,
    };

    this.props
      .protectedFetch(
        apiEndpoints.ticket.changeLocation(this.props.details?.id),
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson,
      )
      .then(() => {
        alert("Change location succes");
        this.setState({ loading: false, showAssignStoreLocation: false });
        this.props.retrieveWarranty(); //mini reload
      })
      .catch((err) => {
        console.log("fail", err);
        this.setState({ loading: false });
      });
  };

  getWarrantyTypeOptions = () => {
    const { statusTicketType } = this.state;
    const brandTagName =
      this.props?.details?.user_device?.device?.brand?.tag || "";

    let warrantyTypes = [];

    if (statusTicketType === "out_of_warranty") {
      warrantyTypes = referenceLibrary.ooWarrantyTypes;
    } else if (brandTagName === "steelseries") {
      warrantyTypes = referenceLibrary.ooWarrantyTypesSteelseries;
    } else {
      warrantyTypes = referenceLibrary.warrantyTypes;
    }

    return warrantyTypes;
  };

  render() {
    const completed = [
      "Completed",
      "replacement sent",
      "service completed",
    ].map((element) => element.toLowerCase());
    const disableNext =
      this.props.details?.ticket_status_list?.indexOf(
        this.props.details?.status,
      ) ===
        this.props.details?.ticket_status_list?.length - 1 ||
      completed.includes(this.props.details?.status.toLowerCase());

    const due_date =
      (this.props.details?.due_date &&
        new Date(this.props.details?.due_date)) ||
      this.state.due_date;
    const selectedServiceCenterCentralValue =
      this.props.optionServiceCenterCentrals?.find(
        (x) => x.value === this.state.serviceCenterCentralId,
      );
    const selectedServiceCenterLocationValue =
      this.props.optionServiceCenterLocations?.find(
        (x) => x.value === this.state.serviceCenterLocationId,
      );

    const tempdAssignTo = this.props?.employees?.find(
      (s) => s && s.id === this.state.employeeID,
    );

    const selectedAssignTo = tempdAssignTo && {
      value: tempdAssignTo.id,
      label: `${tempdAssignTo.name} - ${tempdAssignTo.user_role}`,
    };

    const isCommercial = ["Commercial Staff", "Commercial Admin"].includes(
      this.props.userInfo?.user.role,
    );

    let assignTo = [];
    if (this.props?.employees) {
      assignTo = this.props?.employees.map((s) => {
        return { value: s.id, label: s.combine_name };
      });

      if (this.props.details?.service_center) {
        const assignToTemp = this.props?.employees.map((s) => {
          return { value: s.id, label: s.combine_name };
        });
        let assignToT2 = [];
        [...assignTo, ...assignToTemp].forEach((a) => {
          if (!assignToT2.map((x) => x.value).includes(a.value))
            assignToT2.push(a);
        });
        assignTo = assignToT2;
      }
    }

    const isReturnLabelSent = this.isReturnLabelSent();
    const isDisableSC =
      !(
        this.props.userInfo?.user.role === "Admin" ||
        !this.props.details?.service_center_central
      ) || !isReturnLabelSent;

    const isDisableSCLoc = !(
      this.props.userInfo?.user.role === "Admin" ||
      this.props.userInfo?.user.role === "Service Center Admin"
    );

    const serviceCenterTooltip = !isReturnLabelSent
      ? "Cannot change service center because label has been sent. If you want to change the service center, contact admin"
      : "";

    const statusListOption = this.props.details?.ticket_status_list?.map(
      (status) => {
        return {
          value: status,
          label: getStatusLabel(this.props.details, status),
        };
      },
    );
    const selectedReplacement = this.props.deviceOptions?.find(
      (x) => x.value === this.props.details?.replacement,
    );

    let nextOption = [];
    switch (this.props.details?.status) {
      case "Pending Repair":
        nextOption = referenceLibrary.pendingRepairStatuses.map((st) => {
          return { value: st, label: st };
        });
        break;
      case "Awaiting Parts":
        nextOption = referenceLibrary.awaitingPartStatuses.map((st) => {
          return { value: st, label: st };
        });
        break;
      case "Goods received and under repair":
        nextOption = referenceLibrary.underRepairStatuses.map((st) => {
          return { value: st, label: st };
        });
        break;
      default:
      // code block
    }

    const isRepairStatus = referenceLibrary.repairStatuses.includes(
      this.props.details?.status,
    );

    const goodReceivedIndex =
      this.getStatusIndex("Pending Receipt of Goods") ||
      this.getStatusIndex("Return Label Link Sent, Pending Receipt of Goods") ||
      this.getStatusIndex("Spare Parts Approved, Pending Dispatch");

    const isUnLocked =
      this.getStatusIndex(this.props.details?.status) - goodReceivedIndex < 1
        ? true
        : false;

    const brandTagName =
      this.props.details?.user_device?.device?.brand?.tag || "";

    const returnLabelConfig = [
      {
        status: "Pending Customer to Download Return Label",
        value: this.props.details?.return_label,
      },
      {
        status: "Return Label Link Sent",
        value: this.state.serviceCenterLocationData?.return_label_link || "",
      },
      {
        status: "Pending Receipt of Goods",
        value: this.state.serviceCenterLocationData?.return_label_link || "",
      },
      {
        status: "Return Label Link Sent, Pending Receipt of Goods",
        value: this.state.serviceCenterLocationData?.return_label_link || "",
      },
    ];

    const matchValueReturnLabel =
      this.props.details?.ticket_status &&
      returnLabelConfig.find((config) =>
        this.props.details.ticket_status.some((ticket) =>
          ticket.status.includes(config.status),
        ),
      );

    return (
      <div className="card mb-3 " id="ticket-process">
        <h4 className={"card-header"}>
          Ticket #{this.props.details?.ticket_number}
        </h4>
        <div className="card-body">
          <div>
            <b> Ticket type:</b>
            <select
              data-testid="ticket-type-select"
              className="drop-down-tc form-select"
              onChange={(e) => this.handleTicketTypeChanges(e)}
              defaultValue={this.state.statusTicketType}
              disabled={!isUnLocked || isCommercial}
            >
              <option value="warranty"> Warranty </option>
              {brandTagName !== "steelseries" && (
                <option value="out_of_warranty"> Out of Warranty</option>
              )}
            </select>
          </div>

          <div>
            <b>Type of service:</b>
            <select
              data-testid="service-type-select"
              className="drop-down-tc form-select"
              disabled={!isUnLocked || isCommercial}
              onChange={(e) => this.handleStatusTicketTypeModal(e)}
              value={this.state.typeService}
            >
              <option value="">----- Choose Type ----- </option>
              {this.getWarrantyTypeOptions()
                ? this.getWarrantyTypeOptions()?.map((wt) => (
                    <option key={wt.value} value={wt.value}>
                      {wt.label}
                    </option>
                  ))
                : null}
            </select>
          </div>

          <div>
            {!this.props.details?.status
              ?.toLowerCase()
              .includes("service completed") &&
              !this.props.details?.status
                ?.toLowerCase()
                .includes("not approved") &&
              !this.props.details?.status
                ?.toLowerCase()
                .includes("did not proceed") &&
              !isCommercial && (
                <div>
                  <div>
                    <b>Due Date:</b>
                  </div>
                  <DatePicker
                    data-testid="due-date-picker"
                    id="ticket-datepicker"
                    className="form-control"
                    selected={due_date}
                    dateFormat="dd/MM/yyyy"
                    onChange={(val) =>
                      this.setState({
                        due_date: val,
                        showDueDateModal: true,
                      })
                    }
                  />
                </div>
              )}
          </div>

          {!this.props.userInfo.user.role.includes("Commercial") && (
            <div className="card p-2 mt-2 mb-2" style={{ zIndex: 0 }}>
              <Stepper
                stepList={this.props.details?.ticket_status_list}
                statuses={this.props.details?.ticket_status}
                statusLabels={this.props.details?.status_labels}
              />
            </div>
          )}
          {this.props.details?.ticket_status_list?.indexOf(
            this.props.details?.status,
          ) > -1 &&
            ["Admin", "Service Center Admin"].includes(
              this.props.userInfo?.user.role,
            ) && (
              <div
                className={`single-warranty-details text-start ${
                  this.props.details?.status?.includes("Pending Approval")
                    ? "d-none"
                    : "mb-2"
                }`}
              >
                <b>Status: </b>
                <div className="w-auto">
                  <Select
                    isDisabled={isCommercial}
                    data-testid="select-status"
                    className="text-start"
                    value={{
                      value: this.state.statusTicket,
                      label: getStatusLabel(
                        this.props.details,
                        this.state.statusTicket,
                      ),
                    }}
                    options={statusListOption}
                    isSearchable={true}
                    onChange={(obj) => {
                      this.handleStatusTicket(obj);
                    }}
                  />
                </div>
              </div>
            )}
          {this.props.details?.out_of_warranty && (
            <div className={"warranty-out-of-warranty-flag"}>
              Out of Warranty
            </div>
          )}
          <div
            className={`single-warranty-details text-start ${
              this.props.details?.status?.includes(
                "Goods received pending replacement to be sent",
              )
                ? "mb-2"
                : "d-none"
            }`}
          >
            <b>Replacement: </b>
            <div className="ticket_submit-wrapper">
              <Select
                isDisabled={isCommercial}
                data-testid="assign-to-select"
                value={selectedReplacement}
                isSearchable={true}
                options={this.props.deviceOptions}
                onChange={(obj) => {
                  this.handleDropDownReplacement(obj);
                }}
              />

              <button
                disabled={isCommercial}
                data-testid="assign-to-btn"
                onClick={() => this.setState({ replacementModal: true })}
                type="button"
                className="k-btn k-btn-outline-primary k-btn-sm"
              >
                Save
              </button>
            </div>
          </div>
          <div
            className={`single-warranty-details text-start ${
              [
                "Repair complete, goods sent out",
                "Replacement Sent",
                "Spare Parts Dispatched, Issue Resolved",
              ].includes(this.props.details?.status)
                ? "mb-2"
                : "d-none"
            }`}
          >
            <div className={"single-warranty-details text-start"}>
              <b>Tracking Number to Customer:</b>
              <div className="ticket_submit-wrapper">
                <input
                  type="text"
                  data-testid={"tracking-number"}
                  id="trackingNumber"
                  value={this.state.trackingNumber || ""}
                  className="form-control h-100"
                  onChange={(e) => this.handleInputChange(e)}
                />

                <button
                  data-testid={"tracking-number-btn"}
                  onClick={(e) => this.handleSubmitTrackingNumber(e)}
                  className="k-btn k-btn-outline-primary k-btn-sm"
                >
                  Save
                </button>
              </div>
            </div>
          </div>

          <div
            className={`single-warranty-details text-start ${
              this.props.details?.tracking_number_service ? "mb-2" : "d-none"
            }`}
          >
            <div className={"single-warranty-details text-start"}>
              <b>Tracking Number to Service:</b>
              <div className="ticket_submit-wrapper">
                <label
                  disabled
                  data-testid={"tracking-number"}
                  id="trackingNumber"
                  className="form-control h-100"
                >
                  {this.props.details?.tracking_number_service}
                </label>
              </div>
            </div>
          </div>

          <div
            className={`single-warranty-details text-center ${
              this.props.details?.status?.includes(
                "Pending Return Label to be Sent",
              ) && !isCommercial
                ? "mb-2"
                : "d-none"
            }`}
          >
            {this.props.details?.status_flow === "upload_pdf" ? (
              <div className="m-3 d-flex justify-content-center">
                <button
                  className="k-btn k-btn-outline-primary text-center"
                  onClick={() => this.setState({ showShipping: true })}
                >
                  Return Label
                </button>
              </div>
            ) : (
              <div className="m-3 d-flex justify-content-center">
                <button
                  className="k-btn k-btn-outline-primary text-center"
                  onClick={() => this.setState({ showReturnLabel: true })}
                >
                  Send Return Label Link to Customer
                </button>
              </div>
            )}
          </div>

          <div
            className={`single-warranty-details text-center ${
              isCommercial ? "mb-2 mt-2" : "d-none"
            }`}
          >
            {matchValueReturnLabel ? (
              <div className="d-flex justify-content-center">
                <a
                  className="text-decoration-none"
                  rel="noreferrer"
                  target="_blank"
                  href={matchValueReturnLabel.value}
                >
                  <div className="k-btn k-btn-outline-primary d-flex align-items-center justify-content-center">
                    Return Label
                  </div>
                </a>
              </div>
            ) : null}
          </div>

          <Tooltip title={serviceCenterTooltip}>
            <div
              className={`single-warranty-details text-start ${
                isCommercial ? "d-none" : "mb-2"
              }`}
            >
              <b>Service Center: </b>
              <Select
                data-testid="service-center-central"
                value={selectedServiceCenterCentralValue}
                options={this.props.optionServiceCenterCentrals ?? []}
                isSearchable={true}
                isDisabled={isDisableSC || this.state.isDisabled}
                onChange={(obj) => {
                  this.handleDropDownServiceCenterCentral(obj);
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    cursor:
                      isDisableSC || this.state.isDisabled
                        ? "not-allowed"
                        : "pointer",
                  }),
                }}
              />
            </div>
          </Tooltip>

          <div
            className={`single-warranty-details text-start ${
              isCommercial ? "d-none" : "mb-2"
            }`}
          >
            <b>Service Center Location: </b>
            <Select
              data-testid="service-center-location"
              value={selectedServiceCenterLocationValue}
              options={this.props.optionServiceCenterLocations ?? []}
              isSearchable={true}
              isDisabled={isDisableSCLoc || this.state.isDisabled}
              onChange={(obj) => {
                this.handleDropDownServiceCenterLocation(obj);
              }}
            />
          </div>

          <div
            className={`single-warranty-details text-start ${
              isCommercial ? "d-none" : "mb-2"
            }`}
          >
            <b>Assign Location</b>
            <div className="ticket_submit-wrapper">
              <Select
                required
                options={this.props.locationOptions}
                value={this.props.locationOptions.find(
                  (sl) => sl.value === this.state.storeLocationId,
                )}
                store_location
                placeholder="Assign Location"
                onChange={(e) => {
                  const curStoreLocId =
                    this.props.locationOptions.find(
                      (l) => l.label === this.state.storeLocationLabel,
                    )?.value || "";
                  this.setState({
                    currentStoreLocationId: curStoreLocId,
                    storeLocationId: e.value,
                    storeLocationLabel: e.label,
                    storeLocationChanged: curStoreLocId !== e.value,
                  });
                }}
                // onInputChange={(val) => this.searchLocationState(val)}
              />

              <button
                data-testid="assign-to-btn"
                onClick={() => this.setState({ showAssignStoreLocation: true })}
                type="button"
                className="k-btn k-btn-outline-primary k-btn-sm"
              >
                Save
              </button>
            </div>
          </div>
          <div
            className={`single-warranty-details text-start ${
              isCommercial ? "d-none" : "mb-2"
            }`}
          >
            <b>Assigned to: </b>
            <div className="ticket_submit-wrapper">
              <Select
                data-testid="assign-to-select"
                value={selectedAssignTo}
                isSearchable={true}
                isDisabled={this.state.isDisabled}
                options={assignTo}
                onChange={(obj) => {
                  this.handleDropDownAssignTo(obj);
                }}
              />

              <button
                data-testid="assign-to-btn"
                onClick={() => this.setState({ showAssignModal: true })}
                type="button"
                className="k-btn k-btn-outline-primary k-btn-sm"
              >
                Save
              </button>
            </div>
          </div>
          {!isCommercial && (
            <div className={"single-warranty-details"}>
              <b>Solvup ID:</b>
              <span>
                <div className="ticket_submit-wrapper">
                  <div className="input-group">
                    <input
                      type="text"
                      data-testid={"solvupId"}
                      id="solvupId"
                      value={this.state.solvupId}
                      className="form-control h-100"
                      onChange={(e) => this.handleInputChange(e)}
                    />
                  </div>
                  <button
                    data-testid={"refund-amount-btn"}
                    onClick={(e) => this.handleSubmitSolvupId(e)}
                    className="k-btn k-btn-outline-primary  k-btn-sm"
                  >
                    Save
                  </button>
                </div>
              </span>
            </div>
          )}

          {!isCommercial && (
            <div className={"single-warranty-details"}>
              <b>Refund Amount:</b>
              <span>
                <div className="ticket_submit-wrapper">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">AUD</span>
                    </div>
                    <input
                      type="text"
                      data-testid={"refund-amount"}
                      id="refundAmount"
                      value={this.state.refundAmount}
                      className="form-control h-100"
                      onChange={(e) => this.handleInputChange(e)}
                    />
                  </div>
                  <button
                    data-testid={"refund-amount-btn"}
                    onClick={(e) => this.handleSubmitRefund(e)}
                    className="k-btn k-btn-outline-primary  k-btn-sm"
                  >
                    Submit
                  </button>
                </div>
              </span>
            </div>
          )}

          {!isCommercial && (
            <div className={"single-warranty-details"}>
              <b>Inbound:</b>
              <span>
                <div className="ticket_submit-wrapper">
                  <div className="input-group">
                    <input
                      type="text"
                      data-testid={"inboundTicket"}
                      id="inboundTicket"
                      value={this.state.inboundTicket}
                      className="form-control h-100"
                      onChange={(e) => this.handleInputChange(e)}
                    />
                  </div>
                  <button
                    data-testid={"inbound-ticket-btn"}
                    onClick={(e) => this.handleSubmitInboundTicket(e)}
                    className="k-btn k-btn-outline-primary  k-btn-sm"
                  >
                    Save
                  </button>
                </div>
              </span>
            </div>
          )}

          {!isCommercial && (
            <div className={"single-warranty-details"}>
              <b>Outbound:</b>
              <span>
                <div className="ticket_submit-wrapper">
                  <div className="input-group">
                    <input
                      type="text"
                      data-testid={"outboundTicket"}
                      id="outboundTicket"
                      value={this.state.outboundTicket}
                      className="form-control h-100"
                      onChange={(e) => this.handleInputChange(e)}
                    />
                  </div>
                  <button
                    data-testid={"outbound-ticket-btn"}
                    onClick={(e) => this.handleSubmitOutboundTicket(e)}
                    className="k-btn k-btn-outline-primary  k-btn-sm"
                  >
                    Save
                  </button>
                </div>
              </span>
            </div>
          )}

          {!this.props.userInfo.user.role.includes("Commercial") && (
            <div className={"single-warranty-details"}>
              <b>Created By:</b>
              <span>
                <div className="ticket_submit-wrapper">
                  <div className="input-group">
                    <input
                      disabled
                      type="text"
                      data-testid={"refund-amount"}
                      id="refundAmount"
                      value={this.state.createdByRole}
                      className="form-control h-100"
                      onChange={(e) => this.handleInputChange(e)}
                    />
                  </div>
                </div>
              </span>
            </div>
          )}

          {this.props.warrantySteps[this.props.details?.status] &&
            this.props.warrantySteps[this.props.details?.status].next && (
              <button
                className={"button"}
                onClick={() => {
                  this.setState({ showNextStepModal: true });
                }}
              >
                {
                  this.props.warrantySteps[this.props.details?.status]
                    .buttonText
                }
              </button>
            )}

          {["Service", "Staff", "Service Center Admin"].includes(
            this.props.userInfo?.user.role,
          ) ? (
            <div className="card-footer d-flex  justify-content-between gap-2">
              <button
                className={
                  disableNext
                    ? "btn btn-outline-secondary disabled  m-1 btn-block"
                    : "btn btn-outline-danger  m-1 btn-block"
                }
                onClick={() => {
                  this.setState({ showDeclineModal: true });
                }}
                data-testid={"reject-btn"}
                disabled={disableNext}
              >
                Reject
              </button>
              <button
                data-testid={"next-btn"}
                className={
                  disableNext
                    ? "btn btn-outline-secondary disabled  m-1 btn-block"
                    : "btn btn-outline-primary  m-1 btn-block"
                }
                onClick={this.handleNextModalOpen}
                disabled={disableNext}
              >
                Next
              </button>
            </div>
          ) : null}
          {this.props.details?.ticket_status_list?.indexOf(
            this.props.details?.status,
          ) === goodReceivedIndex && (
            <small className="text-info text-start">
              Ticket Type and Type of Service are about to be locked on the next
              status
            </small>
          )}
        </div>
        {this.props.details?.status?.includes("Pending Approval") &&
          ["Admin", "Approver", "Service Center Admin"].includes(
            this.props.userInfo?.user.role,
          ) && (
            <div className="card-footer d-flex  justify-content-between gap-2">
              <button
                data-testid={"approve-btn"}
                className={"k-btn k-btn-primary-full"}
                onClick={() => {
                  this.setState({ showApproveModal: true });
                }}
              >
                Approve
              </button>
              <button
                data-testid={"decline-btn"}
                className={"k-btn k-btn-outline-primary-full"}
                onClick={() => {
                  this.setState({ showDeclineModal: true });
                }}
              >
                Decline
              </button>
            </div>
          )}
        {/* {this.props.details?.return_label && (
          <div className="py-auto m-3">
            <a href={this.props.details?.return_label} target="_blank" rel="noreferrer" className="k-btn k-btn-outline-primary-full h-auto">
              View Return Label
            </a>
          </div>
        )} */}
        <DueDateModal
          isOpen={this.state.showDueDateModal}
          disableBtnDueDate={this.state.disableBtnDueDate}
          onSave={() => this.changeDueDate(false)}
          onClose={() =>
            this.setState({ showDueDateModal: false, dueDateReason: "" })
          }
        />
        <StatusConfirmModal
          isOpen={this.state.modalStatusConfirm}
          statusTicket={getStatusLabel(
            this.props.details,
            this.state.statusTicket,
          )}
          onConfirm={(e) => this.handleConfirmTicket(e)}
          onCancel={this.handleCancel}
        />
        <ServiceTypeModal
          isOpen={this.state.modalServiceType}
          typeService={this.state.typeService}
          statusTicketType={this.state.statusTicketType}
          onConfirm={(e) => this.handleChangeStatusTicketType(e)}
          onCancel={this.handleCancel}
        />
        <AssignToModal
          isOpen={this.state.showAssignModal}
          employeeID={this.state.employeeID}
          newAssignTo={this.state.newAssignTo}
          employeeName={this.state.employeeName}
          onAssign={() => this.handleSubmitAssign()}
          onClose={this.handleCancel}
        />
        <AssignStoreLocationModal
          isOpen={this.state.showAssignStoreLocation}
          storeLocationChanged={this.state.storeLocationChanged}
          storeLocationLabel={this.state.storeLocationLabel}
          onAssign={() => this.handleChangeTicketLocation()}
          onClose={() => this.setState({ showAssignStoreLocation: false })}
        />
        <ApproveModal
          isOpen={this.state.showApproveModal}
          details={this.props.details}
          isDoa={this.state.isDoa}
          onSetDoa={(val) => this.setState({ isDoa: val })}
          onApprove={(e) => this.handleApprove(e)}
          onClose={() => this.setState({ showApproveModal: false })}
        />
        <DeclineModal
          isOpen={this.state.showDeclineModal}
          declineReason={this.state.declineReason}
          onDeclineReasonChange={this.handleInputChange}
          onDecline={(e) => this.handleDecline(e)}
          onClose={() => this.setState({ showDeclineModal: false })}
        />
        <NextStepModal
          isOpen={this.state.showNextStepModal}
          warrantySteps={this.props.warrantySteps}
          status={this.props.details?.status}
          onNextStep={this.handleNextStep}
          onClose={() => this.setState({ showNextStepModal: false })}
        />
        <TicketNextModal
          isOpen={this.state.modalNext}
          details={this.props.details}
          isRepairStatus={isRepairStatus}
          nextOption={nextOption}
          onSetNextStatus={(val) => this.setState({ nextStatus: val })}
          onConfirm={(e) => this.handleServiceNext(e)}
          onCancel={this.handleCancel}
        />
        <ServiceCenterModal
          isOpen={this.state.modalServiceCenter}
          newServiceCenter={this.state.newServiceCenter}
          serviceCenterCentralId={this.state.serviceCenterCentralId}
          onSubmitServiceCenter={() =>
            this.handleSubmitServiceCenterCentral(
              this.state.serviceCenterCentralId,
            )
          }
          onCancel={() =>
            this.setState({ modalServiceCenter: false, serviceCenterCentralId: 0 })
          }
        />
        <GoodReceivedModal
          isOpen={this.state.showGoodReceived}
          details={this.props.details}
          onClose={() => this.setState({ showGoodReceived: false })}
          onServiceNext={() => this.handleServiceNext()}
        />
        <ReplacementModal
          isOpen={this.state.replacementModal}
          replacement={this.state.replacement}
          onConfirm={() => this.replacement()}
          onClose={() => this.setState({ replacementModal: false })}
        />
        <ReturnLabelModal
          isOpen={this.state.showReturnLabel}
          onConfirm={() => this.sentRetunLabelLink()}
          onClose={() => this.setState({ showReturnLabel: false })}
        />
        <ShippingModal
          isOpen={this.state.showShipping}
          image={this.state.image}
          imageName={this.state.imageName}
          details={this.props.details}
          onFileUpload={this.handleFileUpload}
          onSave={() => this.uploadLabel()}
          onClose={() => this.setState({ showShipping: false })}
        />
      </div>
    );
  }
}
